<template>
    <div>
        <a-spin :spinning="spinning">
            <a-form-model
                :model="registerFrom"
                ref="registerForm"
                :rules="registerRules"
            >
                <!-- 账号 -->
                <a-form-model-item prop="phone">
                    <div class="input">
                        <svg-icon
                            icon-class="icon_acount"
                            class="icon"
                        ></svg-icon>
                        <a-input
                            v-model="registerFrom.phone"
                            placeholder="请输入邮箱或手机号"
                        />
                    </div>
                </a-form-model-item>
                <!-- 验证码 -->
                <a-form-model-item prop="code">
                    <div class="input">
                        <svg-icon icon-class="icon_ver" class="icon"></svg-icon>
                        <a-input
                            v-model="registerFrom.code"
                            placeholder="请输入验证码"
                            :maxLength="6"
                        />
                    </div>
                    <a-button
                        class="login_btn ver"
                        @click="sendSMS($event)"
                        :class="!showCodeBtn ? 'not' : ''"
                    >
                        <span v-if="showCodeBtn">获取验证码</span>
                        <span v-else>{{ count }}s</span>
                    </a-button>
                </a-form-model-item>
                <!-- 密码 -->
                <a-form-model-item prop="password">
                    <div class="input">
                        <svg-icon
                            icon-class="icon_password"
                            class="icon"
                        ></svg-icon>
                        <a-input
                            v-model="registerFrom.password"
                            placeholder="请输入新密码"
                            type="password"
                        />
                    </div>
                </a-form-model-item>
                <!-- 确认密码 -->
                <a-form-model-item prop="confirm">
                    <div class="input">
                        <svg-icon
                            icon-class="icon_password"
                            class="icon"
                        ></svg-icon>
                        <a-input
                            v-model="registerFrom.confirm"
                            placeholder="请再次输入密码！"
                            type="password"
                        />
                    </div>
                </a-form-model-item>
                <a-form-model-item class="login">
                    <a-button class="login_btn" @click="register">
                        修改密码
                    </a-button>
                </a-form-model-item>
                <div class="form-footer">
                    <span class="login_span underline" @click="swicthLogin(0)">
                        去登录
                    </span>
                </div>
            </a-form-model>
        </a-spin>
        <Verify
            :showVerify="showVerify"
            @success="onSuccess"
            @fail="onFail"
        />
    </div>
</template>
<script>
import { Base64 } from 'js-base64'
import Verify from '@/components/common/Verify'
import { SendSMS } from '@/api/common'
import { Register , Forget} from '@/api/login'
import { setToken } from '@/utils/auth'
export default {
    components:{
        Verify
    },
    data() {

        let validatePhone = (rule, value, callback) => {
            const regEmail =
                /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
            const regMobile =
               /^0?(13[0-9]|14[1-9]|15[012356789]|16[56]|17[0-9]|18[0-9]|19[189])[0-9]{8}$/;
            if (value === '') {
                callback(new Error('请输入邮箱或手机号'))
            } else if (regEmail.test(value) || regMobile.test(value)) {
                callback()
                return
            } else {
                callback(new Error('请输入正确邮箱或手机号！'))
            }
        }
        let validateConfirm = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码！'))
            } else if (value !== this.registerFrom.password) {
                callback(new Error('两次输入密码不一致！'))
            } else {
                callback()
            }
        }
        return {
            // 注册
            registerFrom: {
                phone: '',
                password: '',
                code: '',
                confirm: '',
            },
            // 验证规则
            registerRules: {
                phone: [
                    {
                        required: true,
                        message: '请输入邮箱或手机号',
                        trigger: 'blur',
                    },
                    { validator: validatePhone, trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
                code: [
                    {
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur',
                    },
                ],
                confirm: [{ validator: validateConfirm, trigger: 'blur' }],
            },
            // 接口获取的验证码
            code: '',
            // 计时器
            timer: '',
            count: '',
            showCodeBtn: true,
            // loading
            spinning: false,
            // 图形验证
            showVerify: false,
        }
    },
    methods: {
        // 切换登录方式
        swicthLogin(type) {
            this.$emit('change', type)
        },
        onFail() {
            this.$message.error('请点击鼠标左键，滑动至缺口!')
        },
        onSuccess() {
            SendSMS(this.registerFrom.phone)
                .then((res) => {
                    this.$message.success(res.msg)
                    this.code = res.data
                    let leftTime = 60
                    if (!this.timer) {
                        this.count = leftTime
                        this.showCodeBtn = false
                        // 开启定时器
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= leftTime) {
                                this.count--
                            } else {
                                this.showCodeBtn = true
                                clearInterval(this.timer)
                                this.timer = null
                            }
                        }, 1000)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    this.$message.error(e)
                })
            setTimeout(() => {
                this.showVerify = false
            }, 500)
        },
        // 获取验证码
        sendSMS(event) {
            if (!this.showCodeBtn) return
            this.$refs.registerForm.validateField(['phone'], (err, values) => {
                if (!err) {
                    this.showVerify = true
                } else {
                    console.log(err)
                }
            })
        },
        // 注册
        async register() {
            this.$refs.registerForm.validate((valid) => {
                if (valid) {
                    this.spinning = true
                    const { phone, password, code } = this.registerFrom
                    const data = Base64.encode(
                        JSON.stringify({ phone, password, code })
                    )
                    Forget(data)
                        .then((res) => {
                            this.$message.success(res.msg)
                            this.$store.commit('user/setToken',res.data)
                            this.$store.dispatch('user/getUserInfo').then(res => {
                                this.spinning = false
                                this.$emit('change', 0)
                                this.$router.push({path:'/'})
                            }).catch(err => {
                                console.log(err);
                            })
                            
                            
                        })
                        .catch((e) => {
                            console.log(e)
                            this.$message.error(e)
                            this.spinning = false
                        })
                } else {
                    return false
                }
            })
        },
    },
}
</script>
<style scoped lang="less">
@import '~@/assets/css/login.less';
</style>